import { OmniDashboard, OmniDashboardView } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Omni/Omni.Controller.ts
export class OmniAPI {
  static async getDashboards(view: OmniDashboardView): Promise<OmniDashboard[]> {
    return APIService.Server.get<OmniDashboard[]>(`/omni/dashboards?view=${view}`);
  }

  static async getOmniEmbedToken(orgId: number): Promise<string> {
    return APIService.Server.get<string>(`/omni/org/${orgId}/embed-token`);
  }

  static async getOmniIFrameURL(orgId: number, dashboardId: string, locationIds?: string): Promise<string> {
    const params = new URLSearchParams();
    if (locationIds) params.append("locationIds", locationIds);

    const query = params.toString() ? `?${params.toString()}` : "";
    return APIService.Server.get<string>(`/omni/org/${orgId}/dashboard/${dashboardId}/iframe-url${query}`);
  }
}
